import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page, PageTitle } from "@/components/common/page";
import { PageSkeleton } from "@/components/common/states";
import { ConnectBuilder } from "@/components/connect/connect-builder";
import { q } from "@/data/queries";

export const Route = createFileRoute("/p/$project/connect")({
  validateSearch: (search: Record<string, unknown>) => ({
    user: typeof search.user === "string" ? search.user : undefined,
  }),
  loaderDeps: ({ search }) => ({ user: search.user }),
  loader: async ({ context, deps }) => {
    const endUsers = await context.queryClient.ensureQueryData(q.endUsers());
    const endUserId = deps.user ?? endUsers.items[0]?.id ?? "";
    await context.queryClient.ensureQueryData(q.hostedAuthLink(endUserId));
    return { endUserId };
  },
  pendingComponent: PageSkeleton,
  component: ConnectPage,
});

function ConnectPage() {
  const { user } = Route.useSearch();
  const { endUserId } = Route.useLoaderData();
  const { data: endUsers } = useSuspenseQuery(q.endUsers());
  const { data: link } = useSuspenseQuery(q.hostedAuthLink(endUserId));

  return (
    <Page wide>
      <PageTitle
        title="Connect an account"
        description="Build a hosted auth link and send it to one of your users. They link their own account on a page Aux0 serves, so no credential ever reaches you."
      />
      <ConnectBuilder endUsers={endUsers.items} link={link} preselectedUser={user} />
    </Page>
  );
}
